import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Do you really take on small jobs?",
    a: "Yes — genuinely. A cracked plaster patch, a door rehang, a one-day repair. Small jobs are welcome and we respond quickly.",
  },
  {
    q: "Are quotes really free?",
    a: "Yes. Send photos and your postcode and we'll return a clear, no-obligation estimate — typically the same day. Site visits are also free.",
  },
  {
    q: "How fast can you start?",
    a: "Small works often within a week. Larger refurbishments 2–4 weeks out on average. Urgent and out-of-hours starts are usually possible.",
  },
  {
    q: "Do you cover all London postcodes?",
    a: "Yes — Central, East, Greater London including Canary Wharf and the M25 corridor. Based in Dagenham (RM10).",
  },
  {
    q: "Are you licensed and insured?",
    a: "Fully. We carry £10M public liability insurance and are an Environment Agency registered upper-tier waste carrier. Company and VAT registered.",
  },
  {
    q: "Can you do the refurbishment works after the strip-out?",
    a: "Yes. CONSTANTINOV LTD delivers full refurbishment — partitions, M&E, finishes, kitchens and bathrooms — with the same crew and one point of contact.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white text-[#2B2420] py-20 md:py-28"
    >
      <div className="px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
            <span className="brand-gold-divider" /> FAQ
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            Straight answers.
          </h2>
          <p className="mt-5 text-[#8A7F74] max-w-sm">
            Still unsure? Call Ion on{" "}
            <a href="tel:+447591836115" className="underline text-[#2B2420] hover:text-[#B8732C]">
              07591 836115
            </a>{" "}
            or drop a message below.
          </p>
        </div>
        <div className="lg:col-span-8 border-t border-[#E5DDD0]">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-[#E5DDD0]" data-testid={`faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                  className="w-full flex items-start justify-between gap-6 text-left py-6 md:py-7 hover:text-[#B8732C] transition-colors"
                >
                  <span className="font-bold text-lg md:text-xl leading-snug">{item.q}</span>
                  <span className="shrink-0 w-8 h-8 border border-[#2B2420]/20 flex items-center justify-center">
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-7 pr-14 text-[#8A7F74] text-sm md:text-base leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
